import React, { type FC } from 'react';

import type { SyncedBlockFeedbackContext } from '@atlaskit/editor-plugin-synced-block/synced-block-plugin-type';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { TransparentErrorBoundary } from '@confluence/error-boundary/entry-points/TransparentErrorBoundary.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export type SyncedBlockFeedbackCollectorProps = SyncedBlockFeedbackContext & {
	isLivePage: boolean;
	onClose: () => void;
};

const LazySyncedBlockFeedbackCollector: LoadableType<SyncedBlockFeedbackCollectorProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-SyncedBlockFeedbackCollector" */ './SyncedBlockFeedbackCollector.tsx'
				)
			).SyncedBlockFeedbackCollector,
	});

export const SyncedBlockFeedbackCollectorLoader: FC<SyncedBlockFeedbackCollectorProps> = (
	props,
) => (
	<TransparentErrorBoundary attribution={Attribution.EDITOR_CORE} onError={props.onClose}>
		<LazySyncedBlockFeedbackCollector {...props} />
	</TransparentErrorBoundary>
);
